import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/payment-methods/mastercard.svg")